import { Magic } from "magic-sdk";
import { appConfig } from "../util/Constants";

const magic_key = appConfig.REACT_APP_MAGIC_KEY;
const customNodeOptions = appConfig.MAGIC_NETWORK_OPTIONS;

export const magic = new Magic(magic_key, { network: customNodeOptions }); // ✨
